/**
 * Joy Loyalty — Card Member tier-aware styling
 *
 * Match customer hiện tại với tier rồi apply gradient/border/shadow/shimmer
 * theo style "Carriage Trade" (Silver / Gold / Platinum) lên .Avada-Joy_CardMember.
 *
 * Việc map style dựa trên `position` của tier (0/1/2) — đồng bộ với
 * .swiper-slide:nth-child(N) trong VIP Tier block CSS.
 */

(function () {
  'use strict';

  // ===== CONFIG =====
  var CONFIG = {
    cardSelector: '.Avada-Joy_CardMember',
    progressTrackOpacity: 0.25,
    joyWaitTimeoutMs: 10000,
    debug: false
  };
  // ==================

  var STYLE_ID = 'joy-card-tier-style';
  var POS_ATTR = 'data-joy-tier-position';
  var TIER_ATTR = 'data-joy-tier-id';

  var dataCache = { customer: null, tiers: null, loaded: false, loading: null };

  function log() { if (CONFIG.debug) console.log.apply(console, ['[joy-card-tier]'].concat([].slice.call(arguments))); }

  function waitForJoy() {
    return new Promise(function (resolve, reject) {
      if (window.joyInstance && typeof window.joyInstance.customer === 'function') return resolve(window.joyInstance);
      var start = Date.now();
      var iv = setInterval(function () {
        if (window.joyInstance && typeof window.joyInstance.customer === 'function') {
          clearInterval(iv);
          resolve(window.joyInstance);
        } else if (Date.now() - start > CONFIG.joyWaitTimeoutMs) {
          clearInterval(iv);
          reject(new Error('joyInstance not available'));
        }
      }, 150);
    });
  }

  function callFirstAvailable(joy, names) {
    for (var i = 0; i < names.length; i++) {
      if (typeof joy[names[i]] === 'function') {
        try { return Promise.resolve(joy[names[i]]()).catch(function () { return null; }); }
        catch (e) { /* next */ }
      }
    }
    return Promise.resolve(null);
  }

  function loadData() {
    if (dataCache.loaded) return Promise.resolve(dataCache);
    if (dataCache.loading) return dataCache.loading;

    dataCache.loading = waitForJoy()
      .then(function (joy) {
        return Promise.all([
          callFirstAvailable(joy, ['customer']),
          callFirstAvailable(joy, ['tiers', 'vipTiers', 'viptiers', 'getTiers', 'getVipTiers'])
        ]);
      })
      .then(function (results) {
        dataCache.customer = results[0] || null;
        var t = results[1];
        dataCache.tiers = Array.isArray(t) ? t : (t && t.data) || [];
        dataCache.loaded = true;
        return dataCache;
      })
      .catch(function () { dataCache.loaded = true; return dataCache; });

    return dataCache.loading;
  }

  function sortTiers(tiers) {
    return tiers.slice().sort(function (a, b) {
      var pa = typeof a.position === 'number' ? a.position : null;
      var pb = typeof b.position === 'number' ? b.position : null;
      if (pa !== null && pb !== null) return pa - pb;
      return (Number(a.targetPoint) || 0) - (Number(b.targetPoint) || 0);
    });
  }

  function findCurrentTier(customer, tiers) {
    if (!Array.isArray(tiers) || !tiers.length) return null;
    var sorted = sortTiers(tiers);

    if (customer && customer.tierId) {
      var direct = sorted.find(function (t) { return t.id === customer.tierId; });
      if (direct) return { tier: direct, index: sorted.indexOf(direct), sorted: sorted };
    }

    var points = 0;
    if (customer) {
      if (typeof customer.tierPoint === 'number') points = customer.tierPoint;
      else if (typeof customer.point === 'number') points = customer.point;
    }

    var idx = 0;
    for (var i = 0; i < sorted.length; i++) {
      if ((Number(sorted[i].targetPoint) || 0) <= points) idx = i;
      else break;
    }
    return { tier: sorted[idx], index: idx, sorted: sorted };
  }

  function injectStyleOnce() {
    if (document.getElementById(STYLE_ID)) return;
    var css = [
      '.Avada-Joy_CardMember[' + POS_ATTR + '] {',
      '  position: relative;',
      '  overflow: hidden;',
      '  transition: background .4s ease, box-shadow .4s ease;',
      '}',
      '.Avada-Joy_CardMember[' + POS_ATTR + ']::before {',
      '  content: "";',
      '  position: absolute;',
      '  inset: 0;',
      '  background: linear-gradient(135deg, rgba(255,255,255,0.35) 0%, rgba(255,255,255,0) 40%, rgba(255,255,255,0) 60%, rgba(255,255,255,0.25) 100%);',
      '  pointer-events: none;',
      '  z-index: 0;',
      '}',
      '.Avada-Joy_CardMember[' + POS_ATTR + '] > * { position: relative; z-index: 1; }',

      /* TIER 1 — SILVER */
      '.Avada-Joy_CardMember[' + POS_ATTR + '="0"] {',
      '  background: linear-gradient(135deg, #F4F4F6 0%, #D9DBE0 45%, #BFC2C9 70%, #E5E6EA 100%) !important;',
      '  border: 1px solid #C8CAD0;',
      '  box-shadow: 0 2px 12px rgba(28,28,46,0.08);',
      '}',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="0"] .Avada-Joy__ViptierName,',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="0"] .Avada-Joy__VipTier--processText,',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="0"] .Avada-Joy__NameCard,',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="0"] .pointsCustomer,',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="0"] .pointsCustomer strong {',
      '  color: #2C2C3E !important;',
      '}',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="0"] .MuiLinearProgress-bar { background-color: #5A5A6E !important; }',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="0"] .MuiLinearProgress-root { background-color: rgba(90,90,110,0.25) !important; }',

      /* TIER 2 — GOLD */
      '.Avada-Joy_CardMember[' + POS_ATTR + '="1"] {',
      '  background: linear-gradient(135deg, #F7E9C2 0%, #E2C173 40%, #C9A24A 70%, #EBD489 100%) !important;',
      '  border: 1px solid #C9A24A;',
      '  box-shadow: 0 4px 18px rgba(201,162,74,0.30);',
      '}',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="1"] .Avada-Joy__ViptierName { color: #4A3611 !important; }',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="1"] .Avada-Joy__VipTier--processText,',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="1"] .Avada-Joy__NameCard,',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="1"] .pointsCustomer,',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="1"] .pointsCustomer strong {',
      '  color: #3D2E0E !important;',
      '}',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="1"] .MuiLinearProgress-bar { background-color: #6B4E14 !important; }',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="1"] .MuiLinearProgress-root { background-color: rgba(107,78,20,0.25) !important; }',

      /* TIER 3 — PLATINUM */
      '.Avada-Joy_CardMember[' + POS_ATTR + '="2"] {',
      '  background: linear-gradient(135deg, #3A3A4E 0%, #1C1C2E 45%, #52527e 75%, #2E2E42 100%) !important;',
      '  border: 1px solid #4A4A5E;',
      '  box-shadow: 0 6px 22px rgba(15,15,28,0.40);',
      '}',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="2"]::after {',
      '  content: "";',
      '  position: absolute;',
      '  top: 0; left: 0; right: 0;',
      '  height: 1px;',
      '  background: linear-gradient(90deg, transparent 0%, rgba(212,175,55,0.6) 50%, transparent 100%);',
      '  z-index: 2;',
      '}',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="2"] .Avada-Joy__ViptierName {',
      '  color: #F2E6C9 !important;',
      '  text-shadow: 0 1px 2px rgba(0,0,0,0.4);',
      '}',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="2"] .Avada-Joy__VipTier--processText,',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="2"] .Avada-Joy__NameCard,',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="2"] .pointsCustomer,',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="2"] .pointsCustomer strong {',
      '  color: #E8E8EC !important;',
      '}',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="2"] .MuiLinearProgress-bar { background-color: #D4AF37 !important; }',
      '.Avada-Joy_CardMember[' + POS_ATTR + '="2"] .MuiLinearProgress-root { background-color: rgba(212,175,55,0.25) !important; }'
    ].join('\n');

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
  }

  function updateProgressBar(card, tier, nextTier, customer) {
    if (!nextTier) return;
    var to = Number(nextTier.targetPoint) || 0;
    var from = Number(tier.targetPoint) || 0;
    if (to <= from) return;

    var points = (customer && (customer.tierPoint || customer.point)) || 0;
    var pct = Math.max(0, Math.min(100, ((points - from) / (to - from)) * 100));

    var bar = card.querySelector('.MuiLinearProgress-bar');
    if (bar) bar.style.transform = 'translateX(' + (pct - 100) + '%)';
    var root = card.querySelector('.MuiLinearProgress-root');
    if (root) root.setAttribute('aria-valuenow', String(Math.round(pct)));
  }

  function clearInlineColorOverrides(card) {
    // Widget tự set inline color/background — phải xoá để CSS gradient của mình thắng
    card.style.removeProperty('background-color');
    var nodes = card.querySelectorAll(
      '.Avada-Joy__ViptierName, .Avada-Joy__VipTier--processText, ' +
      '.Avada-Joy__NameCard, .pointsCustomer, .pointsCustomer strong, ' +
      '.MuiLinearProgress-bar, .MuiLinearProgress-root'
    );
    nodes.forEach(function (el) {
      el.style.removeProperty('color');
      el.style.removeProperty('background-color');
    });
  }

  function applyToCard(card, match, customer) {
    if (!card || !match || !match.tier) return;
    var alreadyStyled = card.getAttribute(TIER_ATTR) === match.tier.id;

    card.setAttribute(POS_ATTR, String(match.index));
    card.setAttribute(TIER_ATTR, match.tier.id || '');
    clearInlineColorOverrides(card);

    var next = match.sorted[match.index + 1] || null;
    updateProgressBar(card, match.tier, next, customer);

    if (!alreadyStyled) log('styled', card, 'tier=', match.tier.name, 'pos=', match.index);
  }

  function applyAll() {
    var cards = document.querySelectorAll(CONFIG.cardSelector);
    if (!cards.length) return;

    injectStyleOnce();

    loadData().then(function (data) {
      var match = findCurrentTier(data.customer, data.tiers);
      if (!match) return log('no tier matched');
      cards.forEach(function (c) { applyToCard(c, match, data.customer); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }

  // Widget mount sau / re-render → re-apply
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      for (var j = 0; j < mutations[i].addedNodes.length; j++) {
        var node = mutations[i].addedNodes[j];
        if (node.nodeType !== 1) continue;
        if ((node.matches && node.matches(CONFIG.cardSelector)) ||
            (node.querySelector && node.querySelector(CONFIG.cardSelector))) {
          applyAll();
          return;
        }
      }
      // Widget tự overwrite inline style sau khi mình clear → bắt thay đổi style attr
      if (mutations[i].type === 'attributes' && mutations[i].attributeName === 'style') {
        var t = mutations[i].target;
        if (t.classList && t.classList.contains('Avada-Joy_CardMember')) {
          clearInlineColorOverrides(t);
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });

  window.joyCardTierColorize = { apply: applyAll, cache: dataCache, config: CONFIG };
})();
